import { Link } from "react-router-dom";

import { docHref, getDocPage } from "@/content/docs/index";

/**
 * Related-page links.
 *
 * Keep adjacent product systems one hop away without expanding the primary
 * navigation into a page for every example or task.
 */
export function DocRelated({ slugs, current }: { slugs?: readonly string[]; current: string }) {
  const pages = (slugs ?? [])
    .filter((slug) => slug !== current)
    .map((slug) => getDocPage(slug))
    .filter((page) => page !== undefined);

  if (pages.length === 0) return null;

  return (
    <section className="mt-14 border-t border-border pt-8" aria-labelledby="related-pages">
      <h2 id="related-pages" className="text-xs font-semibold tracking-wide text-muted-foreground">
        Related
      </h2>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2">
        {pages.map((page) => (
          <li key={page.slug}>
            <Link
              to={docHref(page.slug)}
              className="block h-full rounded-card border border-border px-4 py-3 transition-colors hover:border-primary/40"
            >
              <span className="block text-sm font-medium text-foreground">{page.title}</span>
              <span className="mt-1 block text-xs leading-snug text-muted-foreground">
                {page.description}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
